var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6667 22.3551C17.6667 18.6108 20.953 15.57 25.0001 15.57C29.0471 15.57 32.3333 18.6108 32.3333 22.3551C32.3333 18.6108 35.6197 15.57 39.6666 15.57C43.7136 15.57 47 18.6108 47 22.3551C47 11.121 37.142 2 25.0001 2C12.8581 2 3 11.121 3 22.3551C3 18.6108 6.28638 15.57 10.3333 15.57C14.3803 15.57 17.6667 18.6108 17.6667 22.3551Z",
    stroke: "#FF000C",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2495 16.8744V29.624",
    stroke: "#FF000C",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6672 19.9319C17.6672 19.9319 15.4861 10.8031 25.0006 2",
    stroke: "#FF000C",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2153 19.9317C32.2153 19.9317 33.7353 9.07988 25.7188 2.7865",
    stroke: "#FF000C",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4371 30.973H8.70687C7.31573 30.973 6.18799 32.1008 6.18799 33.4919V42.5647C6.18799 43.9558 7.31573 45.0836 8.70687 45.0836H14.4371C15.8282 45.0836 16.9559 43.9558 16.9559 42.5647V33.4919C16.9559 32.1008 15.8282 30.973 14.4371 30.973Z",
    stroke: "#FF000C",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47021 30.1493V26.8962C8.47021 26.0556 9.15166 25.3741 9.99229 25.3741H11.5144H13.0364C13.8771 25.3741 14.5585 26.0556 14.5585 26.8962V30.1493",
    stroke: "#FF000C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 34.9365H12.5624",
    stroke: "#FF000C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 39.1863H12.5624",
    stroke: "#FF000C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76465 46.6229C7.76465 47.2096 8.24034 47.6854 8.82712 47.6854C9.4139 47.6854 9.88959 47.2096 9.88959 46.6229H7.76465ZM7.76465 45.9066V46.6229H9.88959V45.9066H7.76465Z",
    fill: "#FF000C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1436 46.6229C13.1436 47.2096 13.6192 47.6854 14.206 47.6854C14.7928 47.6854 15.2685 47.2096 15.2685 46.6229H13.1436ZM13.1436 45.9066V46.6229H15.2685V45.9066H13.1436Z",
    fill: "#FF000C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7275 35.1344C36.549 34.8549 36.2379 34.6932 35.9058 34.6868L27.753 34.7738L25.0248 30.5069C24.613 29.8628 23.7609 29.6754 23.117 30.0872C22.473 30.4988 22.2855 31.3511 22.6974 31.995L25.4256 36.2618L21.9258 43.6258C21.8274 43.8379 21.8091 44.0782 21.8744 44.3028C21.9396 44.5272 22.0839 44.7204 22.2807 44.8466C22.4774 44.9728 22.7131 45.0236 22.9443 44.9894C23.1757 44.9552 23.3865 44.8383 23.5382 44.6605L27.6578 39.7531L30.0142 43.4382L29.2874 45.3783C29.2609 45.445 29.2509 45.517 29.2583 45.5884C29.266 45.6598 29.2906 45.7282 29.3306 45.7879L29.6234 46.2457C29.787 46.5017 30.1542 46.5291 30.358 46.3005L32.1699 44.2457L34.7955 43.463C35.0885 43.3742 35.2177 43.0291 35.0539 42.7733L34.7613 42.3156C34.7239 42.2542 34.6722 42.203 34.6106 42.1662C34.549 42.1294 34.4793 42.1082 34.4077 42.1044L32.3416 41.9499L29.9853 38.2648L36.1684 36.5848C36.8001 36.4104 37.0747 35.6773 36.7275 35.1344Z",
    stroke: "#FF000C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/Travel.0d44e7230f24bfa87adbba6f3e32f101.svg";
export { ForwardRef as ReactComponent };